/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'normal': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M481.28 419.84c0 30.72-25.6 61.44-61.44 61.44H76.8c-30.72 0-61.44-25.6-61.44-61.44V76.8c0-30.72 25.6-61.44 61.44-61.44h343.04c30.72 0 61.44 25.6 61.44 61.44v343.04zm0 527.36c0 30.72-25.6 61.44-61.44 61.44H76.8c-30.72 0-61.44-25.6-61.44-61.44V604.16c0-30.72 25.6-61.44 61.44-61.44h343.04c30.72 0 61.44 25.6 61.44 61.44V947.2zm527.36-527.36c0 30.72-25.6 61.44-61.44 61.44H604.16c-30.72 0-61.44-25.6-61.44-61.44V76.8c0-30.72 25.6-61.44 61.44-61.44H947.2c30.72 0 61.44 25.6 61.44 61.44v343.04zm0 527.36c0 30.72-25.6 61.44-61.44 61.44H604.16c-30.72 0-61.44-25.6-61.44-61.44V604.16c0-30.72 25.6-61.44 61.44-61.44H947.2c30.72 0 61.44 25.6 61.44 61.44V947.2z"/>'
  }
})
